import { apiSports } from '@spo/services/api';
import { useMutation } from '@tanstack/react-query';

export const usePatchSportSettings = (
  sportId: number,
  genderIds: number[],
  segmentationId: number | null,
  onSuccess: () => void,
  onError: () => void,
) => {
  return useMutation({
    mutationKey: ['usePatchSportSettings', genderIds, segmentationId],
    mutationFn: () =>
      apiSports.patchSportSettings({
        sportId,
        genderIds,
        segmentationId,
        language: 'EN',
      }),
    onSuccess,
    onError,
  });
};
